export enum TenantPermissions {
  CanPerformTemplatesMgtAdmin = 'can_access_templates_mgt_admin',
}
